import { Download, fileNameWithTime } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eBienLaiPagingActionsObj } from "../../action-types/bien-lai/IBienLaiPagingActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const bienLaiPagingActions = {
  ...generateActions(eBienLaiPagingActionsObj, "BIEN_LAI_PAGING"),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "HUY_ERRR",
    (m: any) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "HUY_SUCCESS",
    (m: any) => {
      NotifyHelper.Success("Hủy thành công");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "EXPORT_EXCEL_BAO_CAO_SUCCESS",
    (data: any) => {
      Download.Excel(data, `${fileNameWithTime("Bảng kê biên lai")}.xlsx`);
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "EXPORT_EXCEL_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "PRINT_BAO_CAO_SUCCESS",
    (data: any) => {
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "PRINT_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "CHANGE_CHO_PHEP_XUAT_HD_SUCCESS",
    (m: any) => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "CHANGE_CHO_PHEP_XUAT_HD_ERRR",
    (m: any) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "SYNC_KE_TOAN_ERRR",
    (m: any) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "SYNC_KE_TOAN_SUCCESS",
    (m: any) => {
      NotifyHelper.Success("Hoàn thành");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "SAVE_IMPORT_SUCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "SAVE_IMPORT_ERROR",
    (m) => {
      NotifyHelper.Error(m ?? "Thất bại");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "IMPORT_SUCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "IMPORT_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
